package com.macrofocus.nastac.ui

fun hexToRgba(hex: String, alpha: Int = 255): Array<Int> {
    val cleanHex = hex.removePrefix("#")
    val value = cleanHex.toLong(16)

    return when (cleanHex.length) {
        3 -> {
            val r = ((value shr 8) and 0xF) * 17
            val g = ((value shr 4) and 0xF) * 17
            val b = (value and 0xF) * 17
            arrayOf(r.toInt(), g.toInt(), b.toInt(), alpha)
        }
        6 -> {
            val r = ((value shr 16) and 0xFF).toInt()
            val g = ((value shr 8) and 0xFF).toInt()
            val b = (value and 0xFF).toInt()
            arrayOf(r, g, b, alpha)
        }
        8 -> {
            val r = ((value shr 24) and 0xFF).toInt()
            val g = ((value shr 16) and 0xFF).toInt()
            val b = ((value shr 8) and 0xFF).toInt()
            val a = if(alpha < 255) alpha else (value and 0xFF).toInt()
            arrayOf(r, g, b, a)
        }
        else -> arrayOf(0, 0, 0, alpha) // fallback
    }
}